export const START_LOADING = "START_LOADING"

export const startLoading = () => ({
    type: START_LOADING,
})
